import {
  buildMetasearchDiscountRequestKey,
  isMetasearchDiscountEnabled,
} from 'lib/metasearch/metasearchDiscountContext'
import { getMetasearchDiscountAmount } from 'selectors/metasearchDiscountSelectors'
import { useAppSelector } from './reduxHooks'
import useMetasearchPriceId from './useMetasearchPriceId'
import { serialiseOccupancy } from 'lib/search/searchUtils'

interface Options {
  propertyId?: string
  checkIn?: string
  checkOut?: string
  rooms?: Array<App.Occupants>
  disabled?: boolean
}

export default function useMetasearchDiscount(
  price: number,
  options: Options = {},
): readonly [number, boolean, boolean] {
  const gpid = useMetasearchPriceId()
  const enabled = isMetasearchDiscountEnabled()
  const discountEnabled = enabled && !options.disabled
  const occupancy = options.rooms ? serialiseOccupancy(options.rooms) : undefined
  const requestKey = discountEnabled && gpid && options.propertyId && options.checkIn && options.checkOut && occupancy?.length && price > 0 ?
      buildMetasearchDiscountRequestKey({
        token: gpid,
        propertyId: options.propertyId,
        checkIn: options.checkIn,
        checkOut: options.checkOut,
        occupancy,
        price,
      }) :
    undefined
  const selectorContext = {
    enabled: discountEnabled,
    requestKey,
  }

  const discountAmount = useAppSelector(state => getMetasearchDiscountAmount(state, selectorContext))
  const isDiscountFetching = useAppSelector(state => !!state.marketing.metasearchDiscount.fetching)
  const discountRequestKey = useAppSelector(state => state.marketing.metasearchDiscount.requestKey)
  const fetching = !!requestKey && isDiscountFetching
  const settled = !requestKey || (discountRequestKey === requestKey && !fetching)

  return [discountAmount, fetching, settled] as const
}
